// extracted by mini-css-extract-plugin
export var actionText = "_if-4";
export var container = "_if-0";
export var leftSection = "_if-1";
export var rightSection = "_if-2";
export var settingsButton = "_if-6";
export var settingsIcon = "_if-7";
export var shortcut = "_if-5";
export var shortcutGroup = "_if-3";